module.exports = "/desktop-app/assets/img/logo.svg?5b70afd32f7486f914dc4db7de882a2b";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/logo.svg
// module id = QEU9
// module chunks = 1